import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useSelector, useDispatch} from 'react-redux'
import {Link, useLocation} from 'react-router-dom'
import '../../UserPages/MyTemplate/Modal/Createtemplate.scss'
import './GiphyPopup.scss'
import {GetAllGiphy, SearchGiphy} from './GiphySlice/GiphySlice'
import {BulkMsgDraftData} from '../../UserPages/new-message/BulkMessageSlice/BulkMessageSlice'

const GiphyPopup = ({show, handleClose, setData, data, bulkMessage}: any) => {
  const dispatch = useDispatch()

  const [searchGiphy, setSearchGiphy] = useState({q: ''})
  const [pagination, setpagination] = useState({
    offset: 0,
    limit: 12,
  })

  const giphy = useSelector((state: any) =>
    state?.Giphy?.Giphy?.data?.map((key: any) => {
      return {id: key?.id, url: key?.images?.fixed_width_downsampled?.url}
    })
  )

  useEffect(() => {
    dispatch(GetAllGiphy({offset: 0, limit: 12}))
  }, [])

  const handleSearch = () => {
    if (searchGiphy.q !== '') {
      let page = {...pagination, offset: 0, limit: 12}
      let data = {...searchGiphy, ...page}
      setpagination({...pagination, offset: 0})
      dispatch(SearchGiphy(data))
    } else {
      let page = {...pagination, offset: 0, limit: 12}
      dispatch(GetAllGiphy(page))
      setpagination({...pagination, ...page})
    }
  }

  const handleClick = (e: any) => {
    if (searchGiphy.q == '') {
      if (e.target.name == 'Previous') {
        let start = pagination.offset > 10 ? pagination.offset : 0
        let page = {...pagination, offset: start - 11, limit: 12}
        let data = {...page}

        setpagination({...pagination, ...page})
        dispatch(GetAllGiphy(data))
      } else {
        let page = {...pagination, offset: pagination.offset + 11, limit: 12}
        let data = {...searchGiphy, ...page}
        setpagination({...pagination, ...page})
        dispatch(GetAllGiphy(data))
      }
    } else {
      if (e.target.name == 'Previous') {
        let start = pagination.offset > 10 ? pagination.offset : 0
        let page = {...pagination, offset: start - 11, limit: 12}
        let data = {...searchGiphy, ...page}

        setpagination({...pagination, ...page})
        dispatch(SearchGiphy(data))
      } else {
        let page = {...pagination, offset: pagination.offset + 11, limit: 12}
        let data = {...searchGiphy, ...page}
        setpagination({...pagination, ...page})
        dispatch(SearchGiphy(data))
      }
    }
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered modal-lg'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h4 style={{fontWeight: 'bold'}} className='modal-title' id='myModalLabel'>
            Select GIF From GIPHY
          </h4>
          <button
            type='button'
            className='close'
            data-dismiss='modal'
            onClick={handleClose}
            aria-hidden='true'
          >
            ×{' '}
          </button>
        </div>

        <div id='campModelErrorBar'></div>
        <div className='modal-body' style={{paddingTop: '0px'}}>
          <div className='add_multiple_weblink mt-8'>
            <div className='input-group'>
              <input
                type='text'
                name='search'
                value={SearchGiphy?.q}
                className='form-control'
                placeholder='Search GIF from GIPHY...'
                onChange={(e: any) => {
                  setSearchGiphy({...searchGiphy, q: e.target.value})
                }}
                onKeyDown={(e: any) => {
                  e.keyCode == 13 && handleSearch()
                }}
              />
              <span className='input-group-btn'>
                <button
                  className='btn btn-secondary'
                  type='button'
                  name='search_submit'
                  id='search_submit'
                  onClick={handleSearch}
                >
                  Go!
                </button>
              </span>
            </div>

            <div className='card-body'>
              <div className='row d-flex'>
                <div className='col-12 template-right'>
                  {/* <span className='fw-bolder d-flex justify-content-start'>MMS</span> */}
                  <div className='row  border-gray-400 template-wrap flex-wrap'>
                    {giphy?.map((key: any, index: any) => {
                      return (
                        <div key={key?.id} className='col-md-4 col-sm-4 col-xs-12 '>
                          <div className='image-box m-3'>
                            <div className='image-tag'>
                              <img
                                onClick={() => {
                                  if (bulkMessage) {
                                    setData({...data, gif: key?.url, media: ''})
                                    dispatch(
                                      BulkMsgDraftData({
                                        ...data,
                                        scheduledAt: '',
                                        gif: key?.url,
                                        media: '',
                                      })
                                    )
                                  } else {
                                    setData({...data, gif: key?.url, media: ''})
                                    dispatch(
                                      BulkMsgDraftData({
                                        ...data,
                                        scheduledAt: '',
                                        gif: key?.url,
                                        media: '',
                                      })
                                    )
                                  }

                                  handleClose()
                                }}
                                className='w-100 border-10 rounded'
                                src={key.url}
                                alt='toyota gif'
                              />
                            </div>
                            {/* <div class="lable-radio">
                                                    <label class="btn  font-bold" style="line-height: 1em;background:white;box-shadow:none;font-size:16px!important;font-weight:bold !important">
                                                        <input type="radio" name="gif_url" value="https://cellcast.com.au/assets/uploads/MmsFileAttachment/default_mms_gif.gif" className="display-none-imp giphy_radio"/>
                                                        <i class="fa fa-circle-o fa-5x" style="font-size:18px"></i>
                                                        <i class="fa fa-circle fa-5x" style="font-size:18px;color:#4D90FD;"></i>
                                                    </label>
                                                </div> */}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                  {pagination.offset > 10 && (
                    <button
                      name='Previous'
                      className='btn btn-sm btn-light btn-primary me-2 w-100px p-3 fw-500 me-2'
                      onClick={handleClick}
                    >
                      Previous
                    </button>
                  )}
                  <button
                    name='Next'
                    className='btn btn-sm btn-light btn-primary me-2 w-100px p-3 fw-500 me-2'
                    onClick={handleClick}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(GiphyPopup)
